import React from "react";

import {
	Badge,
	Button,
	Card,
	Divider,
	Picto,
	Title,
} from "@amphore-dev/amphore-lib";
import { t } from "i18next";

import { cn } from "@/utils/cn";

import {
	ONBOARDING_MAX_WIDTH_CLASS,
	ONBOARDING_OPTIONAL_STEPS,
	ONBOARDING_STEPS,
	ONBOARDING_STEP_PICTOS,
} from "../COnboarding";

interface IWelcomeStepProps {
	firstName?: string;
	onStart: () => void;
}

export const WelcomeStep: React.FC<IWelcomeStepProps> = ({
	firstName,
	onStart,
}) => {
	return (
		<Card
			elevation={2}
			className={cn([
				"flex w-full flex-col gap-6",
				ONBOARDING_MAX_WIDTH_CLASS,
			])}
		>
			<div className="flex flex-col items-center gap-4 pt-2 text-center">
				<img
					src="/assets/logo.svg"
					alt=""
					className="pointer-events-none h-16 w-16"
				/>
				<Title as="h1" size="h2">
					{firstName
						? t("onboarding.welcome.title", { name: firstName })
						: t("onboarding.welcome.titleAnonymous")}
				</Title>
				<p className="m-0 max-w-[520px] text-sm leading-[22px] text-[var(--amp-color-sub)]">
					{t("onboarding.welcome.intro")}
				</p>
			</div>
			<Divider />
			<ol className="m-0 flex list-none flex-col p-0">
				{ONBOARDING_STEPS.map((step, index) => (
					<li
						key={step}
						className="flex items-center gap-4 border-[var(--amp-color-border)] py-4 [&:not(:last-child)]:border-b"
					>
						<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--amp-color-primary-tint)] text-[var(--amp-color-primary)]">
							<Picto
								icon={ONBOARDING_STEP_PICTOS[step]}
								className="h-5 w-5"
								currentColor
							/>
						</div>
						<div className="flex min-w-0 flex-1 flex-col gap-0.5">
							<div className="flex items-center gap-2">
								<span className="text-sm font-semibold">
									{index + 1}.{" "}
									{t(`onboarding.steps.${step}.name`)}
								</span>
								{ONBOARDING_OPTIONAL_STEPS.includes(step) && (
									<Badge color="neutral" variant="tint">
										{t("forms.optional")}
									</Badge>
								)}
							</div>
							<span className="text-[13px] leading-5 text-[var(--amp-color-sub)]">
								{t(`onboarding.steps.${step}.summary`)}
							</span>
						</div>
					</li>
				))}
			</ol>
			<Divider />
			<div className="flex items-center justify-between gap-4">
				<span className="text-xs text-[var(--amp-color-sub)]">
					{t("onboarding.welcome.duration")}
				</span>
				<Button onClick={onStart}>
					{t("onboarding.welcome.start")}
				</Button>
			</div>
		</Card>
	);
};
